import { CKEditor } from '@ckeditor/ckeditor5-react';
import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { TextareaAutosize } from '@/components/ui/textarea-autosize';

export default function StepInfo(props) {
  const { step, form, question } = props;
  const [description, setDescription] = useState('');
  const [motivatorText, setMotivatorText] = useState('');

  const handleDescriptionChange = data => {
    const value = data.getData();
    setDescription(value);
    form.setFieldValue('description', value);
  };

  const handleMotivatorTextChange = data => {
    const value = data.getData();
    setMotivatorText(value);
    form.setFieldValue('motivator-texts-attributes.[0].body', value);
  };

  useEffect(() => {
    if (question) {
      setDescription(question.description);
      setMotivatorText(question['motivator-texts'][0]?.body);
    }
  }, [question]);

  return (
    step === 'informacoes' && (
      <div className="page__content mb-12 animate-fade-in">
        <div className="new-questions__header">
          <h2 className="new-questions__title">{form.values.code || t('exams.titleNewQuestion')}</h2>
        </div>

        <div className="new-questions__body">
          <p className="new-questions__subtitle">{t('exams.subtitleMotivatorText')}</p>

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="motivator-texts-attributes"
            >
              {t('exams.formTitleMotivatorText')}
            </label>
            <CKEditor
              editor={Editor}
              data={motivatorText}
              config={{ placeholder: t('exams.pInsertMotivatingText') }}
              onChange={(event, editor) => {
                handleMotivatorTextChange(editor);
              }}
              onBlur={(event, editor) => {
                handleMotivatorTextChange(editor);
              }}
            />
            {form?.touched?.['motivator-texts-attributes']?.[0]?.body && form?.errors?.['motivator-texts-attributes']?.[0]?.body && <span style={{ color: 'red' }}>{form?.errors?.['motivator-texts-attributes']?.[0]?.body}</span>}
          </div>

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="description"
            >
              *{t('exams.formTitleStatementQuestion')}
            </label>

            <CKEditor
              editor={Editor}
              data={description}
              config={{ placeholder: t('exams.pInsertStatement') }}
              onChange={(event, editor) => {
                handleDescriptionChange(editor);
              }}
              onBlur={(event, editor) => {
                handleDescriptionChange(editor);
              }}
            />
            {form?.touched?.description && form?.errors?.description && <span style={{ color: 'red' }}>{form?.errors.description}</span>}
          </div>
        </div>
      </div>
    )
  );
}
